import mock from 'src/utils/mock';
import { ContactPerson as ContactPersonInterface } from 'src/types/contactPerson';
const contactPerson: ContactPersonInterface[] = [
    {
        PersonID: 'CP-1',
        CPName: 'Rakesh  Kumar',
        EmailID: 'contact@Info.com',
        Designation: 'Mgr',
    },
    {
        PersonID: 'CP-2',
        CPName: 'Sudhanshu Kumar Yadav',
        EmailID: 'contact@Info.com',
        Designation: 'Mgr',
    },
];

mock.onPost('/getcperlist/').reply(function (config) {
    return new Promise(function (resolve, reject) {
        setTimeout(function () {
            // get parameters from post request
            resolve([200, contactPerson]);
        }, 1000);
    });
});

mock.onPost('/getcper/').reply((config) => {
    const params = JSON.parse(config.data);
    const idAsString = params.id;
    const contactPersonData = contactPerson.filter((item) => item.PersonID === idAsString)[0];

    return [200, { ...contactPersonData }];
});
